export default __webpack_public_path__ + "static/media/construction.ca194cef.jpg";